import React from "react";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";

/**
 * Atom: açma/kapama anahtarı (`role="switch"`). Değişimi hemen kaydeden
 * ayarlar için — formdaki Aktif/Pasif seçimi için `Checkbox` kullanılır.
 *
 * @param {boolean} checked
 * @param {(next: boolean) => void} onChange
 * @param {string} label - erişilebilir ad (aria-label)
 * @param {boolean} [disabled]
 * @param {"md"|"sm"} [size="md"]
 */
export default function Switch({ checked, onChange, label, disabled = false, size = "md" }) {
  const icon = size === "sm" ? "w-6 h-6" : "w-7 h-7";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className="p-0.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shrink-0"
    >
      {checked ? (
        <FaToggleOn className={`${icon} text-emerald-500 hover:text-emerald-600 transition-colors`} />
      ) : (
        <FaToggleOff className={`${icon} text-gray-300 hover:text-gray-400 transition-colors`} />
      )}
    </button>
  );
}
